/* eslint-disable indent */
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Checkbox, FormControlLabel, FormGroup, Grid, TextField } from '@mui/material'

import { textFieldTypes, variantTypes } from '../../../../../../constants'
import { Logger, LoggerTypes } from '../../../../../../utils'
import { FlowElementBottomButtons } from '../../../FlowElementBottomButtons'
import '../../../common-elements-style.scss'

const defaultValue = {
  name: '',
  description: '',
  uninterrupted: false
}

export const FlowElementTaskAboutPanel = ({ currentTaskInstance, onChangeTask, onSaveTask, errors }) => {
  const { t } = useTranslation()

  const nameValue = `${currentTaskInstance.task.name ? currentTaskInstance.task.name : ''}` || defaultValue.name
  const descriptionValue =
    `${currentTaskInstance.task.description ? currentTaskInstance.task.description : ''}` || defaultValue.description
  const uninterruptedValue = currentTaskInstance.task.uninterrupted ? true : false || defaultValue.uninterrupted

  const [name, setName] = useState(nameValue)
  const [description, setDescription] = useState(descriptionValue)
  const [uninterrupted, setUninterrupted] = useState(uninterruptedValue)

  const _getNewTask = () => {
    const newTask = {
      ...currentTaskInstance,
      task: {
        ...currentTaskInstance.task,
        id: currentTaskInstance.task.id,
        name: name === '' ? null : name,
        description: description === '' ? null : description,
        uninterrupted: uninterrupted === true
      }
      // uninterrupted: uninterrupted === true
    }

    Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementTaskAboutPanel._getNewTask()', { newTask })

    return newTask
  }

  useEffect(() => {
    const newTask = _getNewTask()
    // Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementTaskAboutPanel.useEffect() CHANGED', { newTask })
    onChangeTask(newTask)
  }, [name, description, uninterrupted])

  useEffect(() => {
    setName(nameValue)
    setDescription(descriptionValue)
    setUninterrupted(uninterruptedValue)
  }, [currentTaskInstance])

  const onChangeName = (e) => {
    e.stopPropagation()
    const _value = e.target.value
    Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementTaskAboutPanel.onChangeTitle()', { name: _value })
    setName(_value)
  }

  const onChangeDescription = (e) => {
    e.stopPropagation()
    const _value = e.target.value
    Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementTaskAboutPanel.onChangeDescription()', { description: _value })
    setDescription(_value)
  }

  const onChangeUninterruptedCheckbox = (e) => {
    e.stopPropagation()
    const _value = e.target.value
    Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementTaskAboutPanel.onChangeUninterruptedCheckbox()', {
      uninterrupted: _value
    })
    setUninterrupted(!uninterrupted)
  }

  const onClickSave = (e) => {
    e.stopPropagation()

    Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementTaskAboutPanel.onClickSave()')
    onSaveTask()
    // onSaveTask((taskInstance) => {
    //   Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementTaskAboutPanel.onClickSave().onSaveTask()', { taskInstance })
    // })
  }

  // Logger.trace(LoggerTypes.CONTAINER, 'FlowElementTaskAboutPanel.render()', {
  //   currentTaskInstance,
  //   about: {
  //     name,
  //     description,
  //     uninterrupted,
  //   },
  //   errors
  // })

  return (
    <div className="FlowElementTaskAboutPanel">
      <form>
        <Grid container spacing={2} style={{ padding: '30px 10px 10px' }}>
          {/*  name  */}
          <Grid item xs={12} sm={12}>
            <TextField
              type={textFieldTypes.TEXT}
              name="name"
              id="name"
              value={name}
              variant={variantTypes.OUTLINED}
              label={t('flowActions.tasks.panels.about.name.label')}
              className="common_fullwidth"
              onChange={onChangeName}
              placeholder={t('flowActions.tasks.panels.about.name.placeholder')}
              error={Boolean(errors && errors?.name)}
              helperText={(errors && errors?.name) || ''}
            />
          </Grid>

          {/*  description  */}
          <Grid item xs={12} sm={12} className="common_fullwidth" style={{ marginTop: '15px' }}>
            <TextField
              type={textFieldTypes.TEXT}
              name="description"
              id="description"
              value={description}
              variant={variantTypes.OUTLINED}
              label={t('flowActions.tasks.panels.about.description.label')}
              className="common_fullwidth"
              onChange={onChangeDescription}
              placeholder={t('flowActions.tasks.panels.about.description.placeholder')}
              error={Boolean(errors && errors?.description)}
              helperText={(errors && errors?.description) || ''}
            />
          </Grid>

          {/*  uninterrupted  */}
          <Grid item xs={12} sm={12} className="common_fullwidth">
            <FormGroup>
              <FormControlLabel
                label={t('flowActions.tasks.panels.about.uninterrupted.label')}
                control={<Checkbox checked={uninterrupted} onChange={onChangeUninterruptedCheckbox} />}
              />
            </FormGroup>
          </Grid>
        </Grid>

        <FlowElementBottomButtons onSave={onClickSave} />
      </form>
    </div>
  )
}

FlowElementTaskAboutPanel.displayName = 'FlowElementTaskAboutPanel'

FlowElementTaskAboutPanel.propTypes = {
  currentTaskInstance: PropTypes.object,
  onChangeTask: PropTypes.func.isRequired,
  onSaveTask: PropTypes.func.isRequired,
  errors: PropTypes.array
}

FlowElementTaskAboutPanel.defaultProps = {
  currentTaskInstance: null,
  onChangeTask: () => {},
  onSaveTask: () => {},
  errors: null
}
